import { type State } from '../types';

export const getIsProjectPagesSporkRebrandingEnabled = (state: State): boolean =>
	state.featureFlags.isProjectPagesSporkRebrandingEnabled;
